module.exports = __webpack_public_path__ + "img/1sb_logo_v3_mobile_white.3c44b14.png";